var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 20,
    height: 20,
    fill: "#ebedf0",
    rx: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 20,
    width: 20,
    height: 20,
    fill: "#9be9a8",
    rx: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 20,
    width: 20,
    height: 20,
    fill: "#40c463",
    rx: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 20,
    width: 20,
    height: 20,
    fill: "#30a14e",
    rx: 3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 20,
    width: 20,
    height: 20,
    fill: "#216e39",
    rx: 3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 45,
    width: 20,
    height: 20,
    fill: "#9be9a8",
    rx: 3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 45,
    width: 20,
    height: 20,
    fill: "#40c463",
    rx: 3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 45,
    width: 20,
    height: 20,
    fill: "#30a14e",
    rx: 3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 45,
    width: 20,
    height: 20,
    fill: "#216e39",
    rx: 3
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 45,
    width: 20,
    height: 20,
    fill: "#ebedf0",
    rx: 3
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 70,
    width: 20,
    height: 20,
    fill: "#40c463",
    rx: 3
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 70,
    width: 20,
    height: 20,
    fill: "#30a14e",
    rx: 3
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 20,
    height: 20,
    fill: "#216e39",
    rx: 3
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 70,
    width: 20,
    height: 20,
    fill: "#9be9a8",
    rx: 3
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 70,
    width: 20,
    height: 20,
    fill: "#40c463",
    rx: 3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 145,
    y: 60,
    fontFamily: "Arial, sans-serif",
    fontSize: 40,
    fontWeight: "bold",
    fill: "#2d333b"
  }, "IQ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 110,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: "bold",
    fill: "#2d333b",
    textAnchor: "middle"
  }, "CommitIQ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6d11ee9f8fe1785d7bb7ccbf97a38c48.svg";
export { ForwardRef as ReactComponent };